export const paths = {
  home: '/',
  settings: '/settings',
  manageUsers: '/manage-users',
  editUser: '/edit-user',
  createUser: '/create-user',
  addUser: '/add-user',
  manageThresholds: '/manage-thresholds',
  loyverseEvents: '/loyverse-events',
  inventoryHistory: '/inventory-history',
  missingReceipts: '/missing-receipts',
  items: '/items',
  notFound: '/not-found',
  inventoryValue: '/inventory-value',
  purchasedItems: '/purchased-items',
  inventoryCounts: '/inventory-counts',
  priceChanges: '/price-changes',
  inventoryDiscrepancies: '/inventory-discrepancies',
  salesReports: '/sales-reports',
  refunds: '/refunds',
  events: '/events',
  receipts: '/receipts',
  downloads: '/downloads',
  wallet: '/wallet',
  topup: '/wallet/topup',
  pricing: '/pricing',
  accountsAndShifts: '/accounts-shifts',
  /** Old Employee Activity link; redirects to the Activity Timeline. */
  auditTrail: '/audit-trail',
  activities: '/activities',
  activityTimeline: '/activity-timeline',
  posDeviceActivity: '/pos-device-activity',
  clientDebts: '/client-debts',
  supplierDebts: '/supplier-debts',
};

export const envVars = {
  CLOUDFRONT_PHOTO_URL: import.meta.env.VITE_CLOUDFRONT_PHOTO_URL,
  S3_BUCKET_FOLDER_NAME: import.meta.env.VITE_S3_BUCKET_FOLDER_NAME,
  ADMIN_PASSWORD: import.meta.env.VITE_ADMIN_PASSWORD,
  API_URL: import.meta.env.VITE_BASE_URL,
  LOYVERSE_STORE: import.meta.env.VITE_LOYVERSE_STORE,
  STAGE: import.meta.env.VITE_STAGE,
  MERCHANT_NAME: import.meta.env.VITE_MERCHANT_NAME,
  REGION: import.meta.env.VITE_REGION,
  COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  USER_POOL_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
  COGNITO_IDENTITY_POOL_ID: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
};

export const CLOUDFRONT_PHOTO_URL = envVars.CLOUDFRONT_PHOTO_URL;
export const S3_BUCKET_FOLDER_NAME = envVars.S3_BUCKET_FOLDER_NAME;
